<micro-select-combo #sel
              placeholder="Reactor"
              routerBase="reactors"
              [mode]="mode"
              [(id)]="reactorId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
